export default __webpack_public_path__ + "static/media/lease.e932312c.png";